// extracted by mini-css-extract-plugin
export var wrapper = "Footer-module--wrapper--aNjiJ";
export var content = "Footer-module--content--ehY8J";
export var companyInfo = "Footer-module--companyInfo--9i023";
export var link = "Footer-module--link--U7SJ4";
export var socialmedia = "Footer-module--socialmedia--xQJTu";
export var copyrightModule = "Footer-module--copyrightModule--y8Y0X";
export var copyright = "Footer-module--copyright--TNYIu";
export var linkedinIcon = "Footer-module--linkedinIcon--8MaZ-";
export var facebookIcon = "Footer-module--facebookIcon--GDBEs";